import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

const IMAGES = [
  "https://images.unsplash.com/photo-1593113616348-85c32d202799?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  "https://images.unsplash.com/photo-1551361415-69c87624334f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
];

export default function Projects() {
  const { t } = useI18n();
  const items = t("projects.items");
  return (
    <section className="section-dark py-24 md:py-32 relative overflow-hidden" data-testid="section-projects">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="eyebrow text-[#FAF9F6]/60">{t("projects.eyebrow")}</div>
            <h2 className="mt-4 font-serif-display text-4xl md:text-6xl leading-[1.02] tracking-tight">
              {t("projects.title")}
            </h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-8 self-end text-[#FAF9F6]/75 leading-relaxed text-lg">
            {t("projects.lead")}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {Array.isArray(items) &&
            items.map((p, i) => (
              <motion.article
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="group flex flex-col"
                data-testid={`project-card-${i}`}
              >
                <div className="hero-photo aspect-[4/5] w-full overflow-hidden">
                  <img
                    src={IMAGES[i % IMAGES.length]}
                    alt={p.name}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
                    loading="lazy"
                  />
                </div>
                <div className="mt-5 flex items-center justify-between">
                  <div className="font-mono-mark text-[0.65rem] tracking-[0.3em] uppercase text-[#D97706]">
                    0{i + 1} · {p.location}
                  </div>
                  <div className="font-mono-mark text-[0.65rem] tracking-[0.3em] uppercase text-[#FAF9F6]/50">
                    {p.term}
                  </div>
                </div>
                <h3 className="font-serif-display text-2xl mt-2">{p.name}</h3>
                <p className="text-[#FAF9F6]/60 text-sm mt-1">{p.type}</p>

                <div className="mt-4">
                  <div className="flex items-center justify-between text-xs font-mono-mark tracking-widest uppercase text-[#FAF9F6]/60">
                    <span>{t("projects.funded")}</span>
                    <span className="text-[#FAF9F6]">{p.funded}%</span>
                  </div>
                  <div className="mt-2 h-[3px] w-full bg-white/10 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${p.funded}%` }}
                      viewport={{ once: true }}
                      transition={{ duration: 1.2, delay: 0.2, ease: [0.2, 0.7, 0.2, 1] }}
                      className="h-full bg-[#D97706]"
                    />
                  </div>
                  <div className="mt-3 flex items-center justify-between text-xs text-[#FAF9F6]/70">
                    <span>{t("projects.target_return")}</span>
                    <span className="text-[#FAF9F6]">{p.target_return}</span>
                  </div>
                </div>
              </motion.article>
            ))}
        </div>
      </div>
    </section>
  );
}
